import { Content, Header, Sidebar } from 'components/Layout';
import React from 'react';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import ScrollButton from '../scroolTopButton';
import { ScreenProvider } from 'context/screen-context';
class MainLayout extends React.Component {

  static isSidebarOpen() {
    return document
      .querySelector('.cr-sidebar')
      .classList.contains('cr-sidebar--open');
  }

  componentWillReceiveProps({ breakpoint }) {
    //if (breakpoint !== this.props.breakpoint) {
    this.checkBreakpoint(breakpoint);
    //}
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);




  }

  // close sidebar when
  handleContentClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      MainLayout.isSidebarOpen() &&
      (this.props.breakpoint === 'xs' ||
        this.props.breakpoint === 'sm' ||
        this.props.breakpoint === 'md')
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'xs':
      case 'sm':
      case 'md':
        return this.openSidebar('close');

      case 'lg':
      case 'xl':
      default:
        return this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    if (document.querySelector('.cr-sidebar')) {
      if (openOrClose === 'open') {
        return document
          .querySelector('.cr-sidebar')
          .classList.add('cr-sidebar--open');
      }
      document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
    }
  }

  render() {
    const { children, isLoading } = this.props;
    return (
      <main className="cr-app bg-light">
        {(isLoading) && <div className="cr-page-spinner main-spinner">
          <Spinner color={'primary'} />
        </div>
        }
        <Sidebar />
        <Content fluid onClick={this.handleContentClick}>

          <Header />
          <ScreenProvider value={{width:this.props.Swidth,type:this.props.breakpoint}}>
            {children}
          </ScreenProvider>
          <ScrollButton />
        </Content>
      </main>
    );
  }
}
const mapStateToProps = (state) => ({
  isLoading: (state.uiReducer && state.uiReducer.isMainLoading) ? state.uiReducer.isMainLoading : false,
});
export default connect(mapStateToProps)(MainLayout)

